import { useEffect, useState, useCallback } from 'react';
import silentMentorApi from '../services/silentMentorApi';
import { useAuth } from '../context/AuthContext';

const GUEST_NUDGES = [
  {
    id: 'guest_nudge_1',
    title: 'Personalized AI Study Plans 🎯',
    message: 'Select your target exam to get tailored practice questions, mock tests, and revision nudges.',
    action: { label: 'Explore Exams', type: 'navigate', target: '/signup' },
    variant: 'info'
  }
];

export default function useSilentMentor({ trigger = 'home_feed', placement = 'home_feed_card', limit = 2 } = {}) {
  const [nudges, setNudges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const isAuthenticated = auth?.isAuthenticated;

  const fetch = useCallback(async () => {
    if (!isAuthenticated) {
      setNudges(GUEST_NUDGES);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await silentMentorApi.getNudges({ trigger, placement, limit });
      setNudges(res?.data?.nudges || []);
    } catch (e) {
      setError(e?.message || 'Failed to load nudges');
    } finally {
      setLoading(false);
    }
  }, [trigger, placement, limit, isAuthenticated]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { nudges, loading, error, refresh: fetch };
}
